import req from '../req'

// 会员关系-获取社群列表
export function getList (params) {
  return req.get('/salesperson/customer_base/get_list', params)
}
